import React from 'react';
import styled from "styled-components";
import {AtIcon} from "taro-ui";
//import { Icon } from "@blueprintjs/core";
//import Icon from '@icon-park/react/es/all';
const AtIconWrapper = styled.div<{size:number,backgroundColor:any,borderRadius:any,boxShadow:any,isDisabled:boolean}>`
  width: 100%;
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;

  background:${({backgroundColor})=> backgroundColor||"transparent"};
  border-radius: ${({borderRadius})=> borderRadius};
  box-shadow: ${({boxShadow})=> boxShadow};
  .at-icon{
    font-size: ${({size})=> size}px;
    opacity: ${({isDisabled})=> isDisabled?'.6':'1'};
  }
`

const AtIconWidget = (props:any) => {
  const {size, color, iconName, onClick,backgroundColor,borderRadius,boxShadow, isDisabled} = props;
  return (
    <AtIconWrapper size={size} backgroundColor={backgroundColor}  borderRadius={borderRadius} boxShadow={boxShadow} onClick={onClick} isDisabled={isDisabled}>
      <AtIcon value={iconName} color={color} />
    </AtIconWrapper>
  );
};

export default AtIconWidget;
